import { IconsProps } from './IconsProps';

const ArrowRightLong = ({
  className = '',
  viewBox = '0 0 24 24',
  width = 24,
  height = 24,
  onClick,
  svgFill = 'currentColor',
  role,
  ariaLabel,
  ariaHidden,
}: IconsProps) => {
  return (
    <svg
      className={className}
      viewBox={viewBox}
      width={`${width}px`}
      height={`${height}px`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={onClick}
      fill={svgFill}
      role={role}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <g clipPath="url(#a)">
        <path d="M21.4 12.372v-.002a.619.619 0 0 0-.016-.079.688.688 0 0 0-.037-.184.695.695 0 0 0-.16-.238l-5.665-5.664a.7.7 0 0 0-.99.99l4.475 4.475H2.7a.7.7 0 0 0 0 1.4h16.313l-4.628 4.628a.7.7 0 0 0 .99.99l5.82-5.82a.687.687 0 0 0 .129-.193c.005-.012.016-.02.021-.033a.7.7 0 0 0 .055-.27Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            transform="translate(2 6)"
            d="M0 0h19.4v12.894H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ArrowRightLong;
